/* eslint-disable  */
import { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { Check } from 'lucide-react';

import { InputInterface } from '../utils/forms/FormInterface';

import './style.scss';
import callApi from '../Api/config';
import { APPLICATION_FORM_SERVICES, BUCKET_MANAGEMENT, COUNTRY } from '../constants/EntityName';
import { Role } from '../constants/AppConstant';

interface SelectInputProps {
  formInput: InputInterface;
  setFormData?: any;
  form: any;
  index: number;
  isCreateMode?: boolean;
  formDetails?: any;
}

const RolePermissions = (props: SelectInputProps) => {
  const { formInput, form, formDetails } = props;
  const {
    fieldType: { options },
  } = formInput;

  const [allowedServices, setAllowedServices] = useState<boolean>(false);
  const [allowedCountries, setAllowedCountries] = useState<boolean>(false);
  const [allowedBucket, setAllowedBucket] = useState<boolean>(false);
  const [serviceList, setServiceList] = useState<any[]>([]);
  const [countriesList, setCountriesList] = useState<any[]>([]);
  const [bucketList, setBucketList] = useState<any[]>([]);

  const currentRole = Form.useWatch('role', form);

  const changeHandler = (value: any) => {
    // Find the selected option based on the value
    const selectedOption = options.find((option: any) => option.value === value);
    if (selectedOption?.value === Role.ADMIN_AGENT) {
      setAllowedServices(true);
      setAllowedCountries(true);
      setAllowedBucket(true);
    } else {
      setAllowedServices(false);
      setAllowedCountries(false);
      setAllowedBucket(false);
    }
  };

  const handleParameterCountries = (name: any) => (value: any) => {
    if (value.includes('all')) {
      const selectedCountries = countriesList.map((country: any) => country?.value);
      form.setFieldValue(name, [...selectedCountries]);
      return;
    }
  };

  const handleParameterServices = (name: any) => (value: any) => {
    if (value.includes('0')) {
      const selectedServices = serviceList.map((service: any) => service?.id);
      form.setFieldValue(name, [...selectedServices]);
      return;
    }
  };

  // This useEffect is used for Country and service List API
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const entityData: any = await callApi(`${COUNTRY}`, 'GET');
        // Assuming entityData is an array of country names
        const countryNames: string[] = entityData.data.data;

        // Convert array of strings to array of objects with 'value' and 'name' with 'uniqueId' properties
        const countryData = countryNames.map((countryName, index) => ({
          id: index + 1,
          value: countryName,
          name: countryName,
        }));

        if (countryData) {
          setCountriesList(countryData);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching countries list:', error);
        setCountriesList([]); // Set an empty array in case of an error
      }
    };

    //eslint-disable-next-line
    const getOptions = async () => {
      try {
        const response = await callApi(
          `${BUCKET_MANAGEMENT}/?page=1&limit=100&activeOnly=true`,
          'GET'
        );
        //eslint-disable-next-line
        const tempArr = response?.data?.data?.results?.map((item: any) => {
          return { name: item.title, value: item.title, id: item.id };
        });

        setBucketList(tempArr);
      } catch (error) {
        //eslint-disable-next-line
        console.error('Error fetching options:', error);
        throw error;
      }
    };

    const fetchServices = async () => {
      try {
        const entityData: any = await callApi(`${APPLICATION_FORM_SERVICES}`, 'GET');
        // Assuming entityData is an array of country names

        const services: any[] = entityData?.data?.data?.results;

        const serviceData = services.map(service => ({
          id: service?.id,
          value: service?.name,
          name: service?.name,
        }));

        if (serviceData) {
          setServiceList(serviceData);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching countries list:', error);
        setCountriesList([]); // Set an empty array in case of an error
      }
    };

    fetchCountries();
    fetchServices();
    // getOptions();
    const tempArr = options?.map((item: any) => {
      return { name: item.title, value: item.title, id: item.id };
    });
  }, []);

  useEffect(() => {
    if (formDetails?.role === Role.ADMIN_AGENT) {
      setAllowedServices(true);
      setAllowedCountries(true);
      if (formDetails?.servicesAllowed) {
        form.setFieldValue('servicesAllowed', [...formDetails.servicesAllowed]);
      }
      if (formDetails?.countriesAllowed) {
        form.setFieldValue('countriesAllowed', [...formDetails.countriesAllowed]);
      }
    } else {
      setAllowedServices(false);
      setAllowedCountries(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formDetails]);

  return (
    <>
      <Form.Item
        label={'Role'}
        name={'role'}
        className="text"
        wrapperCol={{ span: 8, offset: 4 }}
        labelCol={{ span: 4 }}
        labelAlign="left"
        rules={[
          {
            required: formInput.required,
            message: formInput.errorMsg,
          },
        ]}
      >
        <Select
          showSearch
          allowClear
          optionFilterProp="label"
          optionLabelProp="displayLabel"
          filterOption={(input, option) => {
            const opt = option as unknown as Record<string, any>;
            const label = String(opt?.searchLabel ?? opt?.name ?? opt?.value ?? '');
            return label.toLowerCase().includes(input.toLowerCase());
          }}
          onChange={changeHandler}
          placeholder={formInput.placeholder}
          disabled={formInput.readonly}
          style={{ width: '100%' }}
          menuItemSelectedIcon={null}
          options={(formInput.fieldType.options ?? []).map((obj: any) => {
            const optionValue = String(obj?.value ?? obj?.name ?? '');
            const searchLabel = String(obj?.label ?? obj?.name ?? optionValue ?? '');
            const isSelected = String(currentRole) === optionValue;
            return {
              ...obj,
              value: obj.value,
              searchLabel,
              displayLabel: searchLabel,
              label: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '2px 0',
                    fontSize: '14px',
                    fontWeight: isSelected ? 600 : 500,
                    color: isSelected ? '#075dc5' : '#1f2937',
                    lineHeight: 1.2,
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      width: '16px',
                      height: '16px',
                      borderRadius: '3px',
                      border: isSelected ? '2px solid #075dc5' : '1.5px solid #94a3b8',
                      backgroundColor: isSelected ? '#075dc5' : '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      transition: 'background-color 0.15s ease, border-color 0.15s ease',
                      boxShadow: isSelected ? '0 1px 3px rgba(7, 93, 197, 0.3)' : 'none',
                    }}
                  >
                    {isSelected && (
                      <Check
                        size={11}
                        strokeWidth={3.5}
                        color="#ffffff"
                        style={{ display: 'block' }}
                      />
                    )}
                  </div>
                  <span
                    style={{
                      flex: 1,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {searchLabel}
                  </span>
                </div>
              ),
            };
          })}
        />
      </Form.Item>
    </>
  );
};

export default RolePermissions;
